<!-- Main content area -->
<div>

<!-- TODO: Enable breadcrumb once nx-pageTitle-box-topline is available -->
@if (showBreadcrumb()) {
  <div class="flex flex-row">
      <div class="grow">
        <nx-pageTitle-box-topline
          [bcRootLvlLabel]="'Aufgaben'"
          [bcRootLvlPath]="'/tasks'">
        </nx-pageTitle-box-topline>
      </div>
  </div>
}

<!-- page subtitle -->
<div class="labelLine flex flex-row basis-full">
  
  <!-- icon, title and tag -->
  <div class="flex flex-row grow mt-1">
    
    <!-- switch between subtitle and title form in edit mode -->
    @if (!isEditMode()) {
      <ng-container *ngTemplateOutlet="taskTitleTemplate"></ng-container>
    } @else {
      <ng-container *ngTemplateOutlet="taskTitleFormTemplate"></ng-container>
    }

  </div>
  <!-- command buttons and menu -->
  <div class="flex flex-row justify-center ml-2">
    @if (!isEditMode()) {
      <nx-command-button
        class="mr-2"
        [style]="'dark'"
        [reloadable]="this"
        [hasCommands]="task()"
        [commandInput]="updateCommandInput()">
      </nx-command-button>
      @if(menuItems()?.length > 0) {
      <nx-default-button
        [style]="'dark'"
        [icon]="'icon-options'"
        [tooltip]="'Mehr'"
        [menuItems]="menuItems()">
      </nx-default-button>
      }
    }
  </div>

</div>

<!-- page subtitle -->
@if (!isEditMode()) {
  <div class="text-[14px] text-gray-500 mt-1 mb-2 flex flex-row items-center gap-2">
      <div class="mt-[2px]">
        {{task()?.taskType?.name}} · Erstellt von <b><app-user-name [user]="task()?.createdBy" /></b>&nbsp;<app-relative-time [timestamp]="task()?.createdDateTime" />
      </div>
  </div>
}
<!-- body -->
<div class="bodyWrapper grid grid-cols-[minmax(67%,1fr)_minmax(13rem,18.125rem)] gap-8 mb-[1.25rem]">

  <!-- left side -->
  <div class="flex flex-col gap-4">
    <!-- switch between description and description form in edit mode -->
    @if (!isEditMode()) {
      <ng-container *ngTemplateOutlet="taskDescriptionTemplate"></ng-container>
    } @else {
      <ng-container *ngTemplateOutlet="taskDescriptionFormTemplate"></ng-container>
    }

  <entity-link-list
    [sourceEntity]="task()"
    [targetEntityType]="'Issue'"
    [linkType]="'RELATED_TO'"
    [headline]="'Vorgang'"
    [emptyMessage]="'Kein Vorgang verbunden'">
  </entity-link-list>

  <app-file-list
    [ownerId]="task()?.id"
    [ownerType]="'Task'"
    [headline]="'Anhänge'"
    [emptyMessage]="'Keine Anhänge vorhanden'">
  </app-file-list>

  <app-timeEntry-list
    [ownerId]="task()?.id"
    [ownerType]="'Task'"
    [headline]="'Zeiterfassung'"
    [emptyMessage]="'Keine Zeiteinträge vorhanden'">
  </app-timeEntry-list>
  
  <app-activity-stream
    #activityStreamRef
    [title]="'Kommentare'"
    [owner]="task()!" 
    [commentsOnly]="true">
  </app-activity-stream>
  
</div>



  <!-- right side -->
  <div class="basis-full flex flex-col">

    <!-- state -->
    <nx-task-status-widget
        class="border-b border-gray mb-2"
        [task]="task()">
    </nx-task-status-widget>

    <!-- due date/time -->
    <nx-task-dueDateTime-widget
        class="border-b border-gray mb-2"
        (reload)="reload()"
        [task]="task()">
    </nx-task-dueDateTime-widget>

    <!-- assignment -->
    <nx-assign-task-widget
        class="border-b border-gray mb-2"
        [task]="task()">
    </nx-assign-task-widget>

    <!-- location -->
    <nx-update-task-location-widget
        class="border-b border-gray mb-2"
        [task]="task()">
    </nx-update-task-location-widget>

    <!-- labels -->
    <!-- TODO: Placeholder - not yet available for tasks -->

    <!-- address -->
    <nx-update-task-address-widget
        class="border-b border-gray mb-2"
        [task]="task()">
    </nx-update-task-address-widget>

    <!-- note -->

    <!-- order link widget -->
    <nx-single-entity-link-widget
      class="border-b border-gray mb-2"
      [entity]="task()"
      [linkedEntityType]="'Order'"
      [linkType]="'RELATED_TO'"
      [placeholder]="'Auftrag auswählen'"
      [label]="'Auftrag'">
    </nx-single-entity-link-widget>

    <!-- contact link widget -->
    <nx-single-entity-link-widget
      class="border-b border-gray mb-2"
      [entity]="task()"
      [linkedEntityType]="'Contact'"
      [linkType]="'RELATED_TO'"
      [placeholder]="'Kunde auswählen'"
      [label]="'Kunde'">
    </nx-single-entity-link-widget>

    <nx-multi-entity-link-widget
      class="border-b border-gray mb-2"
      [entity]="task()"
      [linkedEntityType]="'Resource'"
      [linkType]="'RELATED_TO'"
      [placeholder]="'Resourcen auswählen'"
      [label]="'Ressourcen'">
    </nx-multi-entity-link-widget>

    @if(task()?.order?.note) {
    <nx-default-box-v2
      class="border-b border-gray mb-2">

      <!-- label -->
      <ng-template nxTemplate="label">
        <div class="text-[1rem] font-medium leading-3r mt-[2px]">
        Hinweis
        </div>
      </ng-template>
      {{task()?.order?.note}}
    </nx-default-box-v2>
    }

    @if(task()?.depot) {
    <nx-default-box-v2
      class="border-b border-gray mb-2">

      <!-- label -->
      <ng-template nxTemplate="label">
        <div class="text-[1rem] font-medium leading-3r mt-[2px]">
        Lager
        </div>
      </ng-template>
      {{task()?.depot?.name}}
    </nx-default-box-v2>
    }

  </div>

</div>

<!-- task title template -->
<ng-template #taskTitleTemplate>
  <div class="flex flex-row leading-[1.325rem] min-w-0">
    <div class="mr-1 w-[5px] shrink-0 self-stretch" [ngStyle]="{'background-color': task()?.taskType?.color}"></div>
    <!-- Title row with icon and title -->
    <div class="font-medium text-[20px]">
      <div class="mr-1 float-left w-[18px] h-[18px] mt-[1px]">
        <app-task-type-icon [task]="task()"></app-task-type-icon>
      </div>
      {{task()?.taskType?.prefix}}{{task()?.number}} · {{!titleOverride() ? task()?.title: titleOverride()}}
    </div>
  </div>
</ng-template>

<!-- task title form template -->
<ng-template #taskTitleFormTemplate>
  <div
    class="form w-full mb-2"
    [formGroup]="taskFormGroup()!">
    <nx-edit-text-input
      formControlName="title"
      label="Titel">
    </nx-edit-text-input>
  </div>
</ng-template>

<!-- task description template -->
<ng-template #taskDescriptionTemplate>
  @if (showDescription()) {
  <nx-default-box
    class="bg-white border border-gray rounded-md">
    <ng-template nxTemplate="body">
      @if (task()?.description) {
        <div class="-mt-1">{{ task()?.description }}</div>
      } @else {
        <span class="text-gray-500 -mt-1 block">Keine Beschreibung vorhanden.</span>
      }
    </ng-template>
  </nx-default-box>
  }
  <app-task-complete
    [task]="task()"
    (updateTitle)="onUpdateTitle($event)">
  </app-task-complete>
</ng-template>

<!-- task description form template -->
<ng-template #taskDescriptionFormTemplate>
  <div
    class="form"
   [formGroup]="taskFormGroup()!">

    <nx-textfield-input
      formControlName="description"
      [placeholder]="'Beschreibung eingeben...'"
      label="Beschreibung">
    </nx-textfield-input>
    
    <div class="mt-2">
      @if (isEditMode()) {
        <nx-default-button
          [style]="'dark'"
          [disabled]="!taskFormGroup()?.dirty || taskFormGroup()?.invalid"
          [label]="'Speichern'"
          (click)="saveChanges()">
        </nx-default-button>

        <nx-default-button
          class="ml-2"
          [style]="'dark'"
          [label]="'Abbrechen'"
          (click)="cancelChanges()">
        </nx-default-button>
      }
    </div>
    
  </div>
</ng-template>

</div><!-- End main content area -->